import React, { useState, useContext, useEffect } from "react";
import Layout from "pages/shared/Layout";

import { StoreContext } from "shared/context/store-context";
import { ownerShipTypes, yesNoUnknowTypes, plateTypes } from "shared/util/types";
import { formatDate } from "shared/util/time";
import { PERMISSION_TYPES } from "shared/util/constants";
import { AuthContext } from "shared/context/auth-context";

import InventoryVehicleItem from "./InventoryVehicleItem";

const InventoryVehicles = () => {
  const auth = useContext(AuthContext);
  const itemType = "vehicle";
  const listName = "main_vehicles";

  const { vehicles, DeleteVehicle, UpdateVehicle, InsertVehicle, driverOptions } = useContext(StoreContext);

  const [pageItems, setPageItems] = useState();

  const shouldHighlightDate = (date) => {
    if (!date) {
      return true;
    }
    const currentDate = new Date();
    const oneMonthAfter = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
    return date <= formatDate(oneMonthAfter).split(" ")[0];
  };

  useEffect(() => {
    setPageItems(vehicles);
  }, [vehicles]);

  const listColumns = [
    { field: "plate", headerName: "Plaka", width: 120 },
    {
      field: "isActive",
      headerName: "Aktif",
      width: 100,
      valueGetter: (params) => (params?.row?.isActive ? "Evet" : "Hayır"),
    },
    {
      field: "plateType",
      headerName: "Plaka Tipi",
      width: 150,
      valueGetter: (params) => plateTypes.find((type) => type?.value === params?.row?.plateType)?.label || "",
    },
    {
      field: "ownership",
      headerName: "Sahiplik",
      width: 150,
      valueGetter: (params) => ownerShipTypes.find((type) => type?.value === params?.row?.ownership)?.label || "",
    },
    { field: "department", headerName: "Departman", width: 200 },
    {
      field: "driver",
      headerName: "Sürücü",
      width: 250,
      valueGetter: (params) => {
        try {
          return driverOptions.find((item) => item?.value?.toString() === params?.row?.driver?.toString())?.label || "";
        } catch {
          return "";
        }
      },
    },

    {
      field: "generalInspectionEndDate",
      headerName: "Muayene Bitiş",
      width: 150,
      cellClassName: (params) =>
        shouldHighlightDate(params?.row?.generalInspectionEndDate) ? "highlight-red" : undefined,
    },

    {
      field: "egzozInspectionEndDate",
      headerName: "Egzoz Bitiş",
      width: 150,
      cellClassName: (params) =>
        shouldHighlightDate(params?.row?.egzozInspectionEndDate) ? "highlight-red" : undefined,
    },
    {
      field: "trafficPolicyEndDate",
      headerName: "Trafik Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.trafficPolicyEndDate) ? "highlight-red" : undefined),
    },
    {
      field: "insuranceEndDate",
      headerName: "Kasko Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.insuranceEndDate) ? "highlight-red" : undefined),
    },
    {
      field: "chairPolicyEndDate",
      headerName: "Koltuk Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.chairPolicyEndDate) ? "highlight-red" : undefined),
    },
    {
      field: "roadDocumentC1Date",
      headerName: "C1 Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.roadDocumentC1Date) ? "highlight-red" : undefined),
    },
    {
      field: "roadDocumentC2Date",
      headerName: "C2 Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.roadDocumentC2Date) ? "highlight-red" : undefined),
    },
    {
      field: "d2Date",
      headerName: "D2 Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.d2Date) ? "highlight-red" : undefined),
    },
    {
      field: "valilikDenetimKartiDate",
      headerName: "Valilik Bitiş",
      width: 150,
      cellClassName: (params) =>
        shouldHighlightDate(params?.row?.valilikDenetimKartiDate) ? "highlight-red" : undefined,
    },
    {
      field: "tursabLevhasiDate",
      headerName: "Tursab Bitiş",
      width: 150,
      cellClassName: (params) => (shouldHighlightDate(params?.row?.tursabLevhasiDate) ? "highlight-red" : undefined),
    },
    {
      field: "generalInspectionPhoto",
      headerName: "Muayene Dokümanı",
      width: 150,
      valueGetter: (params) => (params?.row?.generalInspectionPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.generalInspectionPhoto ? undefined : "highlight-red"),
    },
    {
      field: "egzozInspectionPhoto",
      headerName: "Egzoz Dokümanı",
      width: 150,
      valueGetter: (params) => (params?.row?.egzozInspectionPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.egzozInspectionPhoto ? undefined : "highlight-red"),
    },
    {
      field: "trafficPolicyPhoto",
      headerName: "Trafik Poliçesi",
      width: 150,
      valueGetter: (params) => (params?.row?.trafficPolicyPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.trafficPolicyPhoto ? undefined : "highlight-red"),
    },
    {
      field: "insurancePhoto",
      headerName: "Kasko Poliçesi",
      width: 150,
      valueGetter: (params) => (params?.row?.insurancePhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.insurancePhoto ? undefined : "highlight-red"),
    },
    {
      field: "chairPolicyPhoto",
      headerName: "Koltuk Poliçesi",
      width: 150,
      valueGetter: (params) => (params?.row?.chairPolicyPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.chairPolicyPhoto ? undefined : "highlight-red"),
    },
    {
      field: "roadDocumentC1Photo",
      headerName: "C1 Belgesi",
      width: 150,
      valueGetter: (params) => (params?.row?.roadDocumentC1Photo ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.roadDocumentC1Photo ? undefined : "highlight-red"),
    },
    {
      field: "roadDocumentC2Photo",
      headerName: "C2 Belgesi",
      width: 150,
      valueGetter: (params) => (params?.row?.roadDocumentC2Photo ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.roadDocumentC2Photo ? undefined : "highlight-red"),
    },
    {
      field: "d2Photo",
      headerName: "D2 Belgesi",
      width: 150,
      valueGetter: (params) => (params?.row?.d2Photo ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.d2Photo ? undefined : "highlight-red"),
    },
    {
      field: "valilikDenetimKartiPhoto",
      headerName: "Valilik Belgesi",
      width: 150,
      valueGetter: (params) => (params?.row?.valilikDenetimKartiPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.valilikDenetimKartiPhoto ? undefined : "highlight-red"),
    },
    {
      field: "tursabLevhasiPhoto",
      headerName: "Tursab Belgesi",
      width: 150,
      valueGetter: (params) => (params?.row?.tursabLevhasiPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.tursabLevhasiPhoto ? undefined : "highlight-red"),
    },
    {
      field: "startPhoto",
      headerName: "Başlangıç Fotoğrafı",
      width: 150,
      valueGetter: (params) => (params?.row?.startPhoto ? "Evet" : "Hayır"),
      cellClassName: (params) => (params?.row?.startPhoto ? undefined : "highlight-red"),
    },

    { field: "marka", headerName: "Marka", width: 150 },
    { field: "model", headerName: "Model", width: 150 },
    { field: "modelYear", headerName: "Model Yılı", width: 150 },
    { field: "formalCapacity", headerName: "Ruuhsat Kapasite", width: 150 },
    { field: "realCapacity", headerName: "Gerçek Kapasite", width: 150 },

    { field: "owner", headerName: "Sahibi", width: 150 },
    { field: "contact1", headerName: "İletişim", width: 150 },
    { field: "address", headerName: "Adres", width: 150 },
    { field: "yakitOwner", headerName: "Yakıt Sahibi", width: 150 },
    {
      field: "spaceKey",
      headerName: "Yedek Anahtar",
      width: 150,
      valueGetter: (params) => yesNoUnknowTypes.find((type) => type?.value === params?.row?.spaceKey)?.label || "",
    },
    { field: "ruhsatNo", headerName: "Ruhsat No", width: 150 },
    { field: "trackingSerialNo", headerName: "Takip No", width: 150 },
    { field: "uttsSerialNo", headerName: "UTTS No", width: 150 },
    { field: "chassisNo", headerName: "Şasi No", width: 150 },

    { field: "generalInspectionDate", headerName: "Muayene Tarihi", width: 150 },
    { field: "generalInspectionAmount", headerName: "Muayene Ücreti", width: 150 },
    { field: "egzozInspectionDate", headerName: "Egzoz Tarihi", width: 150 },
    { field: "egzozInspectionAmount", headerName: "Egzoz Ücreti", width: 150 },
    { field: "trafficPolicyStartDate", headerName: "Trafik Poliçe Başlangıç", width: 150 },
    { field: "trafficPolicyAmount", headerName: "Trafik Poliçe Ücreti", width: 150 },
    { field: "insuranceStartDate", headerName: "Kasko Başlangıç", width: 150 },
    { field: "insuranceAmount", headerName: "Kasko Ücreti", width: 150 },
    { field: "chairPolicyStartDate", headerName: "Koltuk Poliçe Başlangıç", width: 150 },
    { field: "chairPolicyAmount", headerName: "Koltuk Poliçe Ücreti", width: 150 },

    { field: "startDate", headerName: "Başlangıç Tarihi", width: 150 },
    { field: "startKm", headerName: "Başlangıç Km", width: 150 },
    {
      field: "endPhoto",
      headerName: "Çıkış Fotoğrafı",
      width: 150,
      valueGetter: (params) => (params?.row?.endPhoto ? "Evet" : "Hayır"),
    },
    { field: "endDate", headerName: "Çıkış Tarihi", width: 150 },
    { field: "endKm", headerName: "Çıkış Km", width: 150 },

    { field: "notes", headerName: "Notlar", width: 150 },

    // {
    //   field: "files",
    //   headerName: "Dosyalar",
    //   width: 200,
    //   valueGetter: (params) => params?.row?.folder?.id || "",
    // },
  ];

  const standardHelpItems = [
    "1. Şu anda erişim yetkinizin olduğu Sürücü Bilgileri ekranını görüntülemektesiniz.",
    "2. Filtreleri kullanarak ilgili sürücü bilgilerine daha kolay erişim sağlayabilirsiniz.",
    "3. Sütun isimlerine tıklayarak sıralamayı değiştirebilirsiniz.",
    "4. Yeni sürücü bilgisi eklemek için 'Yeni Sürücü Bilgileri Yarat' butonuna tıklayın.",
  ];

  const highlightedHelpItems = [
    "1. Bu sayfa sistemde tanımlı bir sürücünün bilgilerinin yönetilmesi için tasarlanmıştır. Sürücünün daha önce sistemde tanımlı olması gerekmektedir.",
    "2. Bir sürücünün sistemde tanımlanması için yukarıdaki SÜRÜCÜLER sekmesini kullanınız. Böylece sürücü SERVİSTESİN sistemine dahil edilmiş olacaktır.",
    "3. Ardından tekrar bu sekmeye gelerek SERVİSTESİN sistemine dahil edilen sürücünün bilgilerini 'Yeni Sürücü Bilgileri' yarat tuşuna basarak girebilirsiniz.",
    "4 Kimlik numarası girmediğiniz sürücünün dosya işlemlerini gerçekleştiremezsiniz.",
    "5. Kimlik bilgisi olduğu halde 'Dosyalara Git' tuşunu göremiyorsanız, alttaki Güncelle tuşuna bir kez basınız.",
    "6. Sürücünün kullandığı aracı bu ekranda değiştiremezsiniz. Araç değişikliği için yandaki ARAÇLAR sekmesini kullanınız.",
  ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      showSelectedYear={false}
      isAlwaysFullScreen={true}
      hideCreateNewItem={!auth.permissions[PERMISSION_TYPES.ACCESS_TO_WRITE_INVENTORY]}
      hideRightHeader={false}
      SelectedItemComponent={InventoryVehicleItem}
      NewItemComponent={InventoryVehicleItem}
      DeleteItem={DeleteVehicle}
      InsertItem={InsertVehicle}
      UpdateItem={UpdateVehicle}
      standardHelpItems={standardHelpItems}
      highlightedHelpItems={highlightedHelpItems}
    />
  );
};

export default InventoryVehicles;
